import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col } from 'react-bootstrap';

import locationIcon from '../assets/images/location-icon.png';
import emailIcon from '../assets/images/email-icon.png';
import phoneIcon from '../assets/images/phone-icon.png';
import hoursIcon from '../assets/images/busines-hours.png';

const ContactInfo = () => {
    const { t } = useTranslation();
    const infoBoxes = [
        { icon: locationIcon, title: t('contact_info_location_title'), lines: [t('contact_info_location_desc')] },
        { icon: emailIcon, title: t('contact_info_email_title'), lines: [t('contact_info_email1'), t('contact_info_email2')], isLink: true, linkType: 'mailto:' },
        { icon: phoneIcon, title: t('contact_info_phone_title'), lines: [t('contact_info_phone1'), t('contact_info_phone2')], isLink: true, linkType: 'tel:' },
        { icon: hoursIcon, title: t('contact_info_hours_title'), lines: [t('contact_info_hours_desc')] },
    ];

    return (
        <section className="float-left w-100 position-relative contact-info-con padding-top padding-bottom main-box">
            <Container>
                <div className="heading-title-con text-center">
                    <span className="special-text color-blue d-block wow animate__animated animate__fadeInLeft">{t('contact_info_tag')}</span>
                    <h2 className="wow animate__animated animate__fadeInRight" dangerouslySetInnerHTML={{ __html: t('contact_info_title') }}></h2>
                </div>
                <Row className="all_row">
                    {infoBoxes.map((box, index) => (
                        <Col lg={3} md={6} className="all_column wow animate__animated animate__fadeInDown" data-wow-delay={`${0.4 + index * 0.1}s`} key={index}>
                            <div className="contact-info-box all_boxes">
                                <figure><img src={box.icon} alt={box.title} className="img-fluid" /></figure>
                                <h6>{box.title}</h6>
                                {box.lines.map((line, i) => (
                                    box.isLink ? (
                                        <a href={`${box.linkType}${line}`} className="d-block" key={i}>{line}</a>
                                    ) : (
                                        <p className="mb-0" key={i} dangerouslySetInnerHTML={{ __html: line }}></p>
                                    )
                                ))}
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default ContactInfo;